module.exports = __webpack_public_path__ + "static/media/63532a0b1ca643d86dc10decb3e9ab2f_html_a4e5aa221a8e8a8.959d593f.png";